export default __webpack_public_path__ + "static/media/c_4.f4c89ad6.jpg";